import React, { lazy } from 'react';

const ProgressClaimsPreview = lazy(() =>
  import(
    '../../ClientContractAccountModule/ClientContractPDF/ProgressClaimsPreviewDetailPDF'
  ).then(module => ({ default: module.ProgressClaimsPreviewDetailPDF })),
);

const ContractAdvancePreview = lazy(() =>
  import(
    '../../ClientContractAccountModule/ClientContractPDF/AdvancePreviewDetailPDF'
  ).then(module => ({
    default: module.AdvancePreviewDetailPDF,
  })),
);

const ContractCreditNotesPreview = lazy(() =>
  import(
    '../../ClientContractAccountModule/ClientContractPDF/CreditNotesPreviewDetailPDF'
  ).then(module => ({
    default: module.CreditNotesPreviewDetailPDF,
  })),
);

const ContractDebitNotesPreview = lazy(() =>
  import(
    '../../ClientContractAccountModule/ClientContractPDF/DebitNotesPreviewDetailPDF'
  ).then(module => ({
    default: module.DebitNotesPreviewDetailPDF,
  })),
);

const ContractMiscellaneousPreview = lazy(() =>
  import(
    '../../ClientContractAccountModule/ClientContractPDF/MiscellaneousInvoicesPreviewDetailPDF'
  ).then(module => ({
    default: module.MiscellaneousPreviewDetailPDF,
  })),
);

const ContractReceiptsPreview = lazy(() =>
  import(
    '../../ClientContractAccountModule/ClientContractPDF/ReceiptsPreviewDetailPDF'
  ).then(module => ({
    default: module.ReceiptsPreviewDetailPDF,
  })),
);

const ContractRefundsPreview = lazy(() =>
  import(
    '../../ClientContractAccountModule/ClientContractPDF/RefundsPreviewDetailPDF'
  ).then(module => ({
    default: module.RefundsPreviewDetailPDF,
  })),
);

const ContractRetentionPreview = lazy(() =>
  import(
    '../../ClientContractAccountModule/ClientContractPDF/RetentionPreviewDetailPDF'
  ).then(module => ({
    default: module.RetentionPreviewDetailPDF,
  })),
);

const ClientPreviewDetailPDF = lazy(() =>
  import(
    '../../ClientContractAccountModule/ClientContractPDF/ClientPreviewDetailPDF'
  ).then(module => ({
    default: module.ClientPreviewDetailPDF,
  })),
);

const clientELetterRoutes = [
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/contract-advance/:transactionID/preview',
    },
    component: (
      <ContractAdvancePreview transactionType="Advances" accountType="client" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/contract-credit/:transactionID/preview',
    },
    component: (
      <ContractCreditNotesPreview
        transactionType="Credit Notes"
        accountType="client"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/contract-debit/:transactionID/preview',
    },
    component: (
      <ContractDebitNotesPreview
        transactionType="Debit Notes"
        accountType="client"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/contract-misc/:transactionID/preview',
    },
    component: (
      <ContractMiscellaneousPreview
        transactionType="Miscellaneous Invoices"
        accountType="client"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/contract-receipts/:transactionID/preview',
    },
    component: (
      <ContractReceiptsPreview
        transactionType="Receipts"
        accountType="client"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/contract-refund/:transactionID/preview',
    },
    component: (
      <ContractRefundsPreview transactionType="Refunds" accountType="client" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/contract-claim/:transactionID/preview',
    },
    component: (
      <ProgressClaimsPreview
        transactionType="Claim Summary"
        accountType="client"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/contract-claim/:transactionID/preview',
    },
    component: (
      <ProgressClaimsPreview
        transactionType="Claim Invoice"
        accountType="client"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/contract-claim/:transactionID/preview',
    },
    component: (
      <ProgressClaimsPreview
        transactionType="Claim Workdone"
        accountType="client"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:ID/:contractID/:psType/retention-claim/:transactionID/preview',
    },
    component: (
      <ContractRetentionPreview
        transactionType="Retention Claim"
        accountType="client"
      />
    ),
  },
  ////////////////////ELETTER PREVIEW PDF///////////////
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/contract-advance/:advanceID/e-letter',
    },
    component: (
      <ClientPreviewDetailPDF docType="advances" accountType="client-account" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/contract-credit/:creditNoteID/e-letter',
    },
    component: (
      <ClientPreviewDetailPDF
        docType="credit-note"
        accountType="client-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/contract-debit/:debitNoteID/e-letter',
    },
    component: (
      <ClientPreviewDetailPDF
        docType="debit-note"
        accountType="client-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/contract-misc/:miscInvoiceID/e-letter',
    },
    component: (
      <ClientPreviewDetailPDF
        docType="misc-invoice"
        accountType="client-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/contract-receipt/:receiptID/e-letter',
    },
    component: (
      <ClientPreviewDetailPDF
        docType="official-receipt"
        accountType="client-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/contract-refund/:refundID/e-letter',
    },
    component: (
      <ClientPreviewDetailPDF docType="refund" accountType="client-account" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/contract-retention/:retentionID/e-letter',
    },
    component: (
      <ClientPreviewDetailPDF
        docType="retention-claims"
        accountType="client-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/contract-claim/:claimID/e-letter/claim-summary',
    },
    component: (
      <ClientPreviewDetailPDF
        docType="claim-summary"
        accountType="client-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/contract-claim/:claimID/e-letter/claim-invoice',
    },
    component: (
      <ClientPreviewDetailPDF
        docType="claim-invoice"
        accountType="client-account"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/project-costing/submenu/:contractID/:psType/contract-claim/:claimID/e-letter',
    },
    component: (
      <ClientPreviewDetailPDF
        docType="claim-workdone"
        accountType="client-account"
      />
    ),
  },
];

export default clientELetterRoutes;
